import React, { Component } from 'react';
import Theme from '../../theme';
import PropTypes from 'prop-types';
import { verticalScale } from 'react-native-size-matters';
import { View, Platform, StyleSheet, TouchableOpacity } from 'react-native';
import { FitbeatIcon } from './Icons';
import { defaultScale } from '../../utils/scaling';

class Ratings extends Component {

    setActiveStarNumber = async (activeStarNumber) => {
        this.props.onFinishedRating(activeStarNumber);
    }

    renderStars = () => {
        const { amountOfStars = 5, lightBackground = false, size = defaultScale(40) } = this.props;
        const { input: { value, onChange } } = this.props
        let stars = [];
        const unselectedStarColor = lightBackground ? Theme.GREY_DARK : Theme.GREY
        const selectedStarColor = lightBackground ? Theme.BLACK : Theme.WHITE
        for (let i = 1; i <= amountOfStars; i++) {
            let starImage = selectedStarColor;
            if (i > value) {
                starImage = unselectedStarColor;
            }

            stars.push((
                <TouchableOpacity
                    key={i}
                    style={[ i == 1 ? styles.firstStar : styles.star ]}
                    onPress={() => onChange(i)}>
                    <FitbeatIcon width={size} height={size} color={starImage}/>
                </TouchableOpacity>
            ));
        }
        return stars;
    }

    render() {

        return (
            <View style={styles.container}>
                {this.renderStars()}
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: defaultScale(10),
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    firstStar: {
        paddingLeft: 0,
    },
    star: {
        ...Platform.select({
            default: {
                paddingLeft: defaultScale(10),
            },
            web: {
                paddingLeft: 20,
            }
        }),
    },
    image: {
        width: verticalScale(40, 2),
        height: verticalScale(40, 2),
    }
});

Ratings.propTypes = {
    amountOfStars: PropTypes.number,
    input: {
        onChange: PropTypes.func.isRequired,
        value: PropTypes.number.isRequired,
    },
};

export default Ratings;
